// extracted by mini-css-extract-plugin
module.exports = {"container":"Movie_container__38cOC","innerDiv":"Movie_innerDiv__1359x","overview":"Movie_overview__3ICIJ","btn":"Movie_btn__VhBQO","img":"Movie_img__bD42x"};